module.exports = __webpack_public_path__ + "img/gywm-7.eae39d1b.jpg";